// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../.yarn/__virtual__/css-loader-virtual-2ae40ad6f9/0/cache/css-loader-npm-3.5.3-0f886851e6-e5fa1707d7.zip/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vendor-ledger-summary-wrapper{display:flex;align-items:center;justify-content:center}.vendor-ledger-summary-wrapper .module{flex-basis:33%;padding:0 10px}.vendor-ledger-summary-contact-info{margin:10px 10px 5px 10px;font-size:1em}\n", ""]);
// Exports
module.exports = exports;
